import React from "react";
import Checkbox from "../Checkbox";
import {
  withFormValidation,
  WithFormValidationProps,
} from "./withFormValidation";

interface FormCheckboxProps extends WithFormValidationProps {
  label?: string | React.ReactNode;
  disabled?: boolean;
  required?: boolean;
  helperText?: string;
  size?: "small" | "medium";
  color?: "primary" | "secondary" | "error" | "info" | "success" | "warning";
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({
  label,
  disabled = false,
  required = false,
  helperText,
  size = "medium",
  color = "primary",
  onCheckboxChange,
  ...props
}) => {
  return (
    <Checkbox
      {...props}
      label={label}
      disabled={disabled}
      required={required}
      helperText={helperText}
      size={size}
      color={color}
      onChange={onCheckboxChange}
    />
  );
};

export default withFormValidation(FormCheckbox);
